module.exports = __webpack_public_path__ + "static/media/acc-icon3.b95e4f78.svg";